import { render, staticRenderFns } from "./RedeliveryRequestList.vue?vue&type=template&id=6716aec2&scoped=true&"
import script from "./RedeliveryRequestList.vue?vue&type=script&lang=js&"
export * from "./RedeliveryRequestList.vue?vue&type=script&lang=js&"
import style0 from "./RedeliveryRequestList.vue?vue&type=style&index=0&id=6716aec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6716aec2",
  null
  
)

export default component.exports